Vue.component('projects-filter-component', {
    data: function () {
        return {
            filterActive: false
        }
    },
});